<template>
  <div
    class="modal-footer-v2 pb-6 px-6 flex flex-row justify-end gap-3"
    :class="
      divider
        ? 'pt-[15px] border-t border-gray-100 shadow-[0_-1px_4px_#CACACA29]'
        : 'pt-4'
    "
  >
    <button-v2
      variant="naked"
      color="neutral"
      size="lg"
      class="font-normal"
      @click.prevent="$emit('cancel')"
    >
      {{ cancelText }}
    </button-v2>
    <button-v2
      :type="confirmType"
      :color="variant"
      size="lg"
      class="font-normal"
      :disabled="isDisabled"
      :loading="isLoading"
      @click="$emit('confirm')"
    >
      {{ confirmText }}
    </button-v2>
  </div>
</template>

<script>
import ButtonV2 from './ButtonV2.vue';

export default {
  name: 'ModalFooterV2',
  components: { ButtonV2 },
  props: {
    cancelText: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    isDisabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    confirmType: { type: String, default: 'button' },
    divider: { type: Boolean, default: true },
    variant: {
      type: String,
      default: 'primary',
      validator: value => ['primary', 'danger', 'warning'].includes(value),
    },
  },
};
</script>
